import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, Input, Select, TextArea } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section3({
  data,
  errors,
  onChange
}: SectionProps) {
  return <div className="space-y-6" data-id="element-53">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-54">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-55">
          <span className="text-dorado mr-2" data-id="element-56">Sección 03 ·</span>
          Estado Actual de Salud
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-57">
          Evaluemos tu punto de partida físico.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-58">
        <FormField label="Peso actual (kg/lbs)" name="pesoActual" error={errors.pesoActual} required data-id="element-59">
          <Input id="pesoActual" type="number" value={data.pesoActual} onChange={e => onChange('pesoActual', e.target.value)} error={!!errors.pesoActual} placeholder="Ej. 70" data-id="element-60" />
        </FormField>

        <FormField label="Peso deseado (kg/lbs)" name="pesoDeseado" error={errors.pesoDeseado} required data-id="element-61">
          <Input id="pesoDeseado" type="number" value={data.pesoDeseado} onChange={e => onChange('pesoDeseado', e.target.value)} error={!!errors.pesoDeseado} placeholder="Ej. 65" data-id="element-62" />
        </FormField>
      </div>

      <FormField label={`Nivel de energía actual: ${data.energia || 5}/10`} name="energia" error={errors.energia} required description="1 = Muy baja, 10 = Excelente" data-id="element-63">
        <input type="range" min="1" max="10" value={data.energia || 5} onChange={e => onChange('energia', parseInt(e.target.value))} className="w-full h-2 bg-plateado rounded-lg appearance-none cursor-pointer accent-dorado" data-id="element-64" />
        <div className="flex justify-between text-xs text-gray-500 mt-2" data-id="element-65">
          <span data-id="element-66">Agotado/a (1)</span>
          <span data-id="element-67">Lleno/a de vitalidad (10)</span>
        </div>
      </FormField>

      <FormField label="¿Cómo calificarías tu calidad de sueño?" name="sueno" error={errors.sueno} required data-id="element-68">
        <Select id="sueno" value={data.sueno} onChange={e => onChange('sueno', e.target.value)} error={!!errors.sueno} data-id="element-69">
          <option value="" data-id="element-70">Selecciona una opción...</option>
          <option value="excelente" data-id="element-71">
            Excelente (duermo de corrido y despierto con energía)
          </option>
          <option value="buena" data-id="element-72">
            Buena (duermo bien la mayoría de las noches)
          </option>
          <option value="regular" data-id="element-73">
            Regular (me cuesta dormir o me despierto seguido)
          </option>
          <option value="mala" data-id="element-74">Mala (insomnio, no descanso)</option>
        </Select>
      </FormField>

      <FormField label="¿Tienes alguna condición médica diagnosticada o tomas medicamentos?" name="condiciones" error={errors.condiciones} description="(Opcional) Ej. Hipotiroidismo, hipertensión, resistencia a la insulina, etc." data-id="element-75">
        <TextArea id="condiciones" value={data.condiciones} onChange={e => onChange('condiciones', e.target.value)} error={!!errors.condiciones} placeholder="Si no tienes ninguna, puedes dejar este espacio en blanco." data-id="element-76" />
      </FormField>
    </div>;
}